// extracted by mini-css-extract-plugin
export default {"HasTags":"HasTags_HasTags__uaVlr","Left":"HasTags_Left__yBQ9P","Tag":"HasTags_Tag__XhPEO","Right":"HasTags_Right__nNIu0","Wrapper":"HasTags_Wrapper__Sw0XR"};